import { ConversationModes } from './agent_conversation_modes.enum';
import { Company } from '@/organisations/models';
import { NestedSilverfinCompany } from './nested_silverfin_company.model';
export class Conversation {
    id = 0;
    name = '';
    createdAt = new Date();
    userId = 0;
    activeModes: ConversationModes[] = [];
    companies: NestedSilverfinCompany[] = [];

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.name = data.name ?? '';
        this.createdAt = data.created_at ? new Date(data.created_at) : new Date();
        this.userId = data.user_id ?? 0;
        this.activeModes = data.active_agent_modes ?? [
            ConversationModes.FintraxData,
            ConversationModes.SharePoint,
            ConversationModes.Silverfin,
            ConversationModes.UserData,
        ];
        this.companies= data.companies?.map((c: any) => new NestedSilverfinCompany().deserialize(c)) ?? [];
        return this;
    }

    serialize() {
        return {
            id: this.id,
            name: this.name,
            created_at: this.createdAt,
            user_id: this.userId,
            active_agent_modes: this.activeModes,
            company_ids: this.companies.map(c=> c.id),
        };
    }

    copy() {
        return new Conversation().deserialize(this.serialize());
    }

    static Sort(a: Conversation, b: Conversation) {
        if (a.createdAt > b.createdAt) {
            return -1;
        } else if (a.createdAt < b.createdAt) {
            return 1;
        }
        return 0;
    }
}
